import { render } from "./SliderHome.vue?vue&type=template&id=6dd9d3e8&scoped=true"
import script from "./SliderHome.vue?vue&type=script&lang=js"
export * from "./SliderHome.vue?vue&type=script&lang=js"

import "./SliderHome.vue?vue&type=style&index=0&id=6dd9d3e8&scoped=true&lang=css"

import exportComponent from "/Users/salome/Desktop/salomeg5/bedoya_group/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd9d3e8"]])

export default __exports__